export const DEFAULT_CUSTOM_TEMPLATE_CONFIG = {
  format: { width: 75, height: 13 },
  sku: { position: { x: 31.5, y: 2.5 } },
  collection: { position: { x: 31.5, y: 8 } },
  barcode: { position: { x: 31.5, y: 3.3 }, size: { width: 20, height: 4 } },
  price: { position: { x: 31.5, y: 12 } },
  stock_id: { position: { x: 31.5, y: 9.8 } },
  item: { position: { x: 44.5, y: 9.8 } },
  item_size: { position: { x: 44.5, y: 9.8 } },
  metal: { position: { x: 44.5, y: 9.8 } },
  weight: { position: { x: 45.5, y: 12 } },
  text: { position: { x: 45.5, y: 12 } },
  alignment_locks: {},
  stone_data: {
    line_space_offset: 2.5,
    stone_name: { position: { x: 55, y: 0 } },
    stone_group: { position: { x: 60, y: 0 } },
    clarity: { position: { x: 60, y: 0 } },
    stone_size: { position: { x: 58, y: 0 } },
    shape: { position: { x: 55, y: 0 } },
    color: { position: { x: 60, y: 0 } },
    cut: { position: { x: 60, y: 0 } },
    stone_pcs: { position: { x: 65.5, y: 0 } },
    stone_weight: { position: { x: 69, y: 0 } },
  },
};

export const mergeCustomTemplateConfig = (baseConfig, overrideConfig) => {
  const base = baseConfig || {};
  const override = overrideConfig || {};

  return [...new Set([...Object.keys(base), ...Object.keys(override)])].reduce((result, key) => {
    const baseValue = base[key];
    const overrideValue = override[key];
    if (baseValue === undefined) {
      result[key] = overrideValue;
      return result;
    }
    result[key] = baseValue && typeof baseValue === "object" && !Array.isArray(baseValue)
      ? mergeCustomTemplateConfig(baseValue, overrideValue || {})
      : (overrideValue ?? baseValue);
    return result;
  }, {});
};

export const parseCustomTemplateConfig = (value) => {
  if (value && typeof value === "object") return value;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (error) {
      return null;
    }
  }
  return null;
};

export const hasCustomTemplateConfig = (value) => {
  const parsed = parseCustomTemplateConfig(value);
  return Boolean(parsed && Object.keys(parsed).length > 0);
};
